import { string } from 'yup';

export const emailValidationSchema = string()
  .email('Please enter a valid email address')
  .required('Please enter a valid email address');
